/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import * as codeVerificationNoticeStyles from './CodeVerificationNotice.styles';
import { formatMobileNumber } from '../../utils/formatting';

export interface CodeVerificationNoticeProps {
  phoneNumber: string;
  resend: () => void;
}

function CodeVerificationNotice({ phoneNumber, resend }: CodeVerificationNoticeProps) {
  const { classes: linkClasses } = codeVerificationNoticeStyles.useLinkStyles();
  const { classes: paperClasses } = codeVerificationNoticeStyles.usePaperStyles();
  const { classes: phoneNumberClasses } = codeVerificationNoticeStyles.usePhoneNumberStyles();

  const internationalNumber = formatMobileNumber(phoneNumber);

  return (
    <Paper classes={paperClasses} elevation={0}>
      <Typography component="span" variant="subtitle1">
        {`A 6-digit verification code has been sent to `}
        <span className={phoneNumberClasses.root}>{internationalNumber}</span>.
        <Link component="button" classes={linkClasses} onClick={resend} variant="subtitle1" type="button">
          Resend code
        </Link>
      </Typography>
    </Paper>
  );
}

export default CodeVerificationNotice;
